<script lang="ts">
    import type { NewsFeedPostFragment } from '$gql/graphql.js';
    import { getContainer } from '$components/Context/ContainerContext.js';
    import { fromZonedDateTimeStringToLocalDateOrNull } from '$lib/utils/zonedDateTime';
    import upperFirst from 'lodash/upperFirst';

    let { intl } = getContainer();

    export let post: NewsFeedPostFragment;

    $: startDate = fromZonedDateTimeStringToLocalDateOrNull(
        post.eventStartDate ?? null,
    )?.toDate();
    $: endDate = fromZonedDateTimeStringToLocalDateOrNull(
        post.eventEndDate ?? null,
    )?.toDate();
</script>

{#if post.tag === 'event'}
    <div
        class={'rounded-[4px] px-[12px] py-[8px] border border-solid border-gray-350 bg-gray-150 flex gap-x-[12px]'}
        class:mt-6={post.medias.length > 0}
    >
        <i class={'tnp tnp-calendar-filled text-brand-blue'} aria-hidden={true} />
        <div class="flex gap-[4px] flex-wrap">
            {#if startDate != null}
                <div class={'text-14/[20px] text-gray-800'}>
                    <span class="hidden t:block"
                        >{upperFirst(intl().formatDate(startDate, 'PPPPp'))}</span
                    >
                    <span class="block t:hidden"
                        >{upperFirst(intl().formatDate(startDate, 'PPp'))}</span
                    >
                </div>
            {/if}
            {#if startDate != null && endDate != null}
                <i class="tnp tnp-chevron-right" />
            {/if}
            {#if endDate != null}
                <div class={'text-14/[20px] text-gray-800'}>
                    <span class="hidden t:block"
                        >{upperFirst(intl().formatDate(endDate, 'PPPPp'))}</span
                    >
                    <span class="block t:hidden"
                        >{upperFirst(intl().formatDate(endDate, 'PPp'))}</span
                    >
                </div>
            {/if}
        </div>
    </div>
{/if}
